import React from "react";
import type { FC } from "react";
import { Button } from "@edreamsodigeo/prisma-design-system";

import type { ContinueButtonProps } from "./contract";

const ContinueButton: FC<ContinueButtonProps> = ({
  buttonText,
  buttonType = "primary",
  onClick,
}) => (
  <Button type={buttonType} size={"large"} onClick={onClick}>
    {buttonText}
  </Button>
);

export default ContinueButton;
